/**
 * Client-side CSV/JSON download helpers, shared by every view that exports the
 * data it has already loaded (queue table, report tables). Server-rendered
 * formats (pdf/xlsx) go through their backend export endpoints instead.
 */

const escapeCell = (v: string) => `"${v.replace(/"/g, '""')}"`;

/** Build a CSV string from a header row + string rows (RFC 4180 quoting). */
export function toCsv(columns: string[], rows: string[][]): string {
  return [columns.map(escapeCell).join(','), ...rows.map((r) => r.map(escapeCell).join(','))].join('\r\n');
}

/** Trigger a browser download for the given content. */
export function downloadBlob(content: BlobPart, filename: string, mime: string): void {
  const url = URL.createObjectURL(new Blob([content], { type: mime }));
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

export function downloadCsv(columns: string[], rows: string[][], filename: string): void {
  downloadBlob(toCsv(columns, rows), filename, 'text/csv;charset=utf-8');
}

export function downloadJson(payload: unknown, filename: string): void {
  downloadBlob(JSON.stringify(payload, null, 2), filename, 'application/json');
}
